import { CoreAPI, createAPIMethod } from '@hero/sdk-core';
import {
  VehicleCreateAPI,
  VehicleUpdateAPI,
  VehicleGetManyAPI,
  VehicleGetAPI,
  MyVehicleAPI,
} from '@hero/api';

export function createVehiclesAPI(coreAPI: CoreAPI) {
  return {
    /**
     * Create vehicle
     *
     * API: {@link VehicleCreateAPI}
     */
    createVehicle: createAPIMethod<VehicleCreateAPI>(coreAPI, 'vehicle.createOne'),

    /**
     * Update vehicle
     *
     * API: {@link VehicleUpdateAPI}
     */
    updateVehicle: createAPIMethod<VehicleUpdateAPI>(coreAPI, 'vehicle.updateOne'),

    /**
     * Get many vehicles
     *
     * API: {@link VehicleGetManyAPI}
     */
    getVehicles: createAPIMethod<VehicleGetManyAPI>(coreAPI, 'vehicle.getMany'),

    /**
     * Get vehicle by ID
     *
     * API: {@link VehicleGetAPI}
     */
    getVehicle: createAPIMethod<VehicleGetAPI>(coreAPI, 'vehicle.getOne'),

    /**
     * Get my vehicle (freelancer)
     * Returns the current user's vehicle (for driver type users)
     *
     * API: {@link MyVehicleAPI}
     */
    getMyVehicle: createAPIMethod<MyVehicleAPI>(coreAPI, 'vehicle.getMyVehicle'),
  };
}
